export interface WldTermsContent {
  reviewPageHeaderConsent: string;
  documentShareTermHeader: string;
  documentShareTermContent: string;
  whatIsItHeader: string;
  whatIsItContent: string;
  howShouldIUseIt: string;
  howShouldIUseItContent: string;
  howShouldIUseItContentNote?: string;
  howShouldINotUseItHeader: string;
  howShouldINotUseItContent: string;
  howIsInformationProtHeader: string;
  howIsInformationProtContent: string;
  whatIsInformationUsedHeader: string;
  whatIsInformationUsedContent: string;
  consentAgreement: string;
}
